// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_4ZA","cls2":"BulkDownloadPing-cls2_bCk BulkDownloadPing-cls1_4ZA"};